/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-cancelled': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<g _fill="#6ca2ca"><path pid="0" d="M3.607 16.508l14-11.41a.5.5 0 1 0-.632-.774l-14 11.409a.5.5 0 1 0 .632.775z"/><path pid="1" d="M20 10c0 5.522-4.478 10-10 10S0 15.522 0 10 4.478 0 10 0s10 4.478 10 10zm-1 0a9 9 0 0 0-18 0 9 9 0 0 0 18 0z"/></g>'
  }
})
